import { getDoc, doc } from "firebase/firestore";
import { firestore_database } from "@src/utility_functions/database_operations/config/firebaseConfig";

export const fetchFirestoreUserObjectPublic = async (firestoreID) => {
  let returnValue;
  try {
    const userDocumentReference = doc(firestore_database, "users", firestoreID);
    const userDocumentSnapshot = await getDoc(userDocumentReference);
    const userDocumentSnapshotData = userDocumentSnapshot.data();
    returnValue = userDocumentSnapshotData;
  } catch (error) {
    console.warn(error);
    returnValue = undefined;
  }
  return returnValue;
};
